export const CHALLENGE_CATEGORIES = [
    'Storytelling', 'Characterization', 'Communication',
    'Bridge', 'Tower','Container','Move Balls',
    'Device', 'Invention', 'Sales', 'Improv', 'Water'
  ];
  
  export const CHALLENGE_TYPES = [
    'Task', 'Performance', 'Combination'
  ];
  
  export const CHALLENGE_LEVELS = [
    'Entry', 'Both', 'Advanced'
  ];

  export const TOURNAMENT_LEVELS = [
    'Affiliate', 'Regional'
  ];
  
  